/**
 * @file   str.js
 * @author zhengchanglong<zhengchanglong@baidu.com>
 * @date   2019-10-25
 */

/**
 * 获取字符串字符个数（汉字算俩）
 *
 * @param  {String} str
 * @return {Number}
 */

export function getCharsNum(str) {
    if (typeof str !== 'string') {
        str += '';
    }
    return str.replace(/[^\x00-\xff]/g, 'aa').length;
}

/**
 * Get unique id
 *
 * @param  {String} prefix 前缀
 * @return {String}
 */
let count = 0;
export function guid(prefix = '_') {
    if (count > 999999999999) {
        count = 0;
    }
    count++;
    return prefix
        + Math.random().toString(36).substr(2, 9)
        + Date.now()
        + count;
}
